export default "__VITE_ASSET__CppIRgBO__"